export default "__VITE_ASSET__bee052ca__"